
  export default {
    props: {
      eventName: { type: String, required: true },
      eventAction: { type: String, default: 'cta' },
      eventValue: { type: Number, default: 0 },
      rel: { type: String, default: 'nofollow' },
      target: { type: String, default: '_blank' },
      url: { type: String, required: true },
      urlText: { type: String, required: true }
    },
    computed: {
      outboundLink () {
        if (this.url && this.url.includes('http') === true) {
          return true;
        } else {
          return false;
        }
      }
    },
    methods: {
      trackClick () {
        const event = {
          name: this.eventName,
          value: this.eventValue
        };
        if (this.eventAction === 'proceed') {
          this.$store.dispatch('matomo/trackProceedToProvider', event);
        } else {
          this.$store.dispatch('matomo/trackCTAClick', event);
        }
      }
    }
  };
